/**
 * Feature flags — central kill switch for work-in-progress or gated features.
 *
 * Member system (auth, /member/*, favorites, bookings tracker, tier discount,
 * admin member management): DEFAULT **HIDDEN**.
 *
 * To enable for production:
 *   Vercel dashboard → project → Settings → Environment Variables →
 *   Add: NEXT_PUBLIC_MEMBERS_ENABLED = true (Production)
 *   Then redeploy.
 *
 * To enable locally: add `NEXT_PUBLIC_MEMBERS_ENABLED=true` to `.env.local`.
 *
 * Any file (client or server) can import MEMBERS_ENABLED to gate rendering.
 * proxy.js additionally blocks navigation/API access when disabled.
 *
 * IMPORTANT: flipping this flag does NOT drop data. Member rows in
 * profiles/favorites/bookings/orders stay intact — they just become
 * unreachable from the UI until the flag is turned back on.
 */

export const MEMBERS_ENABLED =
  process.env.NEXT_PUBLIC_MEMBERS_ENABLED === 'true'
